export default __webpack_public_path__ + "static/assets/c80ea036ee5cfbc5613c49e067dab63a.png";